<template>
  <div class="poetryShare">
    <img src="https://dcdn.thecover.cn/robot/poertryBgShare.png" class="bg" id="sharePageImgJs" />
    <div class="peolple">
          <img src="https://dcdn.thecover.cn/robot/poertryPeople.png" />
    </div>
      <div class="title">
        <img src="https://dcdn.thecover.cn/robot/poertryTitle.png" />
      </div>
    <div class="content" id="drawContentWrapper">
    
      <div class="data">
        <div class="innerData">
   <PoetryContent :data="data"></PoetryContent>
        </div>
     
      
      </div>

      <div class="icon">
        <div class="log">
          <img src="https://dcdn.thecover.cn/robot/cgIconBlack.png" />
        </div>
        <div class="code">
          <img src="https://dcdn.thecover.cn/robot/billercode.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PoetryContent from "../Use/poetry-content";
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  components: {
    PoetryContent,
  },
};
</script>
<style lang="less" scoped>
.poetryShare {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: #FF4A50;
  .bg {
    width: 100%;
    height:100%;
  }
.peolple{
    position: absolute;
    top: .682667rem;
    left: 0;
    right: 0;
    width: 6.24rem;
    height: 8.4rem;
    img{
      width: 100%;
      height: 100%;
    }
}
.title{
    position: absolute;
     top: .682667rem;
    left: 6.32rem;
    right: 0;
    width:3.226667rem ;
    height: 3.733333rem;
      img{
      width: 100%;
      height: 100%;
    }
}
  .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 9.0rem;
    margin: 0 auto;
    margin-top:4.506667rem;
      padding-bottom: 0.5rem;

    .data {
      background: rgba(255, 255, 255, 0.5);
      width: 9.0rem;
      // height: 12.373333rem;
      margin-top: 0.446667rem;
      border-radius: 0.106667rem;
      padding-bottom: 0.3rem;
      padding-top: 0.3rem;
      .innerData{
          border-radius: 0.106667rem;
          width: 7.7rem;
                 padding: 4%;
          margin: 0 auto;
          background-color: #fff;
      }
      .data-conent {
        // height: 9rem;
        .top_item {
          height: 90%;
        }
        .bottom_item {
          // bottom: 0.13rem;
        }
      }

    
    }
    .icon {
      margin: 0 auto;
      margin-top: .68rem;

      display: flex;
      justify-content: space-between;
      align-items: center;
      .log {
        width: 4.373333rem;
        height: 1.333333rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .code {
        width: 1.226667rem;
        height: 1.226667rem;
      }
    }
  }
}
</style>
